import * as React from "react";

import { RuntimeDataContext } from "./runtime-data-context";

export function useRuntimeData() {
  const ctx = React.useContext(RuntimeDataContext);
  if (!ctx) {
    throw new Error("useRuntimeData must be used within RuntimeDataProvider");
  }
  return ctx;
}
